import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { setSuccess } from '../actions/loadingActions';
import { FORM_SUBMISSION_SUCCESS } from '../constants/generals';
import { IHistory, IQuestions } from '../interfaces';
import { ChecklistModel } from '../model/ChecklistModel';
import { IMonthlyFormModelProps, MonthlyFormModel } from '../model/MonthlyFormModel';
import { QuestionModel, QuestionModelDuplicate } from '../model/QuestionModel';
import { getCurrentUserUUID, marshallChecklistData, marshallFormDetails, objectToArray, getImageData } from '../utils/generalUtils';
import { getDev, postDev, putDev } from '../utils/HTTPDev';
import { uploadImages } from './formService';
import { getAllPlantsByRegion } from './plantService';

export async function getMonthlyFormList(mm: string, yyyy: string, type: string, region: string) {
    const allInstances = MonthlyFormModel.list();
    allInstances.forEach(instance => {
        new MonthlyFormModel(instance.props).$delete();
    });
    try {
        const response = await getDev(`/forms-m/${mm}/${yyyy}/${getCurrentUserUUID()}/${region || 'All'}`);
        (response.data.data ? response.data.data : []).forEach(element => {
            element.id = element.InspectionUId;
            element.type = element.InspectionId;
            element.UpdatedDate = element.UpdatedDate ? format(element.UpdatedDate, 'MM/DD/YYYY') : 'N/A';
            element.Date = format(element.Date, 'MM/DD/YYYY');
            element.SubmittedDate = format(element.ActualDate, 'MM/DD/YYYY');
            new MonthlyFormModel(element).$save();
        });
        setSuccess('MonthlyFormList');
        return response;
    } catch (error) {
        throw error;
    }
}

export async function getMonthlyFormDetails(formId: string, requestFrom: string = 'nonReport') {
    try {
        const response = await getDev(`/getanswers/${formId}/${requestFrom}`);
        const questionsData: IMonthlyFormModelProps = { id: '', questions: [], ImageUrls: [], Completed: false };
        let formType = response.data.data.FormType; 
        let ReportType = response.data.data.ReportType || '';
        let weatherData: IQuestions;
        let plantData: IQuestions = {
            quesNum: questionsData.questions.length + 1,
            quesvalue: '',
            answer: response.data.data.PlantId,
            question: 'Plant Id',
            flaggedQuestion: false
        };  
        questionsData.questions.push({
            quesNum: questionsData.questions.length + 1,
            quesvalue: '',
            answer: response.data.data.UserName,
            question: 'Submitted By',
            flaggedQuestion: false
        });
        questionsData.questions.push({
            quesNum: questionsData.questions.length + 1,
            quesvalue: '',
            answer: format(response.data.data.ActualDate, 'MM/DD/YYYY'),
            question: 'Submission Date',
            flaggedQuestion: false
        });
        questionsData.questions.push({
            quesNum: questionsData.questions.length + 1,
            quesvalue: '',
            answer: response.data.data.UpdatedBy ? response.data.data.UpdatedBy : 'N/A',
            question: 'Updated By',
            flaggedQuestion: false
        });
        questionsData.questions.push({
            quesNum: questionsData.questions.length + 1,
            quesvalue: '',
            answer:  response.data.data.UpdatedDate ? format(response.data.data.UpdatedDate, 'MM/DD/YYYY'):'N/A', 
            question: 'Updated Date',
            flaggedQuestion: false
        });
        /* questionsData.questions.push({
            quesNum: questionsData.questions.length + 1,
            quesvalue: '',
            answer: response.data.data.PlantId,
            question: 'Plant Id',
            flaggedQuestion: false
        }); */

        objectToArray(response.data.data.Answers).forEach((formDetails, index) => { 
            const instance = marshallFormDetails(formDetails, index, formId);
            if(formType == "MonthlySPCC" && ReportType=='new') {

                if(formDetails.Question=='Time' )
                    return; 
                if(formDetails.Question=='Weather') {
                    weatherData = instance;
                    return;
                } 
                if(instance.quesNum<26)
                    instance.question = instance.quesNum + ') ' + instance.question;
                    
            }
            questionsData.questions.push(instance);
        });
        if(formType == "MonthlySPCC" && ReportType=='new') { 
            questionsData.questions.splice(0, 0, plantData);
            questionsData.questions.splice(5, 0, weatherData);
        } else {
            questionsData.questions.splice(4, 0, plantData);
        }
        if (response.data.data.Completed === 1) {
            questionsData.CompletedBy = response.data.data.CompletedBy;
            questionsData.DateCompleted = format(response.data.data.DateCompleted, 'MM/DD/YYYY');
            questionsData.FollowUpComments = response.data.data.FlaggedComments; 
        }
        questionsData.Associations = response.data.data.Associations;
        questionsData.id = formId;
        questionsData.Completed = response.data.data.Completed !== 0;
        questionsData.ImageUrls = response.data.data.ImageUrls;
        questionsData.SignatureUrls = response.data.data.SignatureUrls;
        questionsData.Flagged = response.data.data.Flagged !== 0;
        questionsData.type = response.data.data.FormType; 
        questionsData.ReportType = response.data.data.ReportType; 
        questionsData.Date = response.data.data.Date; 
        new MonthlyFormModel(questionsData).$save();
        return questionsData;
    } catch (error) {
        throw error;
    }
}

export async function getMonthlyFormAnswers(formId: string) {
    try {
        const response = await getDev(`/getanswers/${formId}`);
        const questionsData: IMonthlyFormModelProps = { id: '', questions: [], ImageUrls: [], Completed: false }; 
        objectToArray(response.data.data.Answers).reverse().forEach((formDetails, index) => {
            const instance = marshallFormDetails(formDetails, index, formId);
            questionsData.questions.push(instance);
        });
        questionsData.id = formId;
        questionsData.ImageUrls = response.data.data.ImageUrls;
        questionsData.SignatureUrls = response.data.data.SignatureUrls;
        /* new QuestionModel(questionsData).$save(); */
        return questionsData;
    } catch (error) {
        throw error;
    }
}

function marshallQuestionAndAnswers(instance, answers, index, type) { 
    const newInstance = {
        question: instance.Question,
        quesNum: instance.Question_Num,
        type: type,
        id: index,
        quesName: `q${instance.Question_Num}`,
        answer: null
    }; 
    const skipForBooleanAnswer = ['weather', 'comments:', 'time',
        'if applicable, explain corrective actions taken since the last inspection:',
        'if any incidents of non-compliance were indentified during the inspection, discuss corrective actions needed:',
        'actions taken', 'volts', 'amps', 'fine', 'coarse', 'description:', 'preventative actions taken'
    ]; 
    if (skipForBooleanAnswer.indexOf(instance.Question.toLowerCase()) >= 0) {
        newInstance.answer = answers.answer;
    } else if (instance.Question.toLowerCase() === 'date') {
        newInstance.answer = new Date(answers.answer);
    } else {
        newInstance.answer = (answers && answers.question === instance.Question) ? answers.answer : null;
    }
    return newInstance;
}

export async function getMonthlyFormQuestions(type: string, formId?: string, year:string = 'na') {
    try {
        const response = await getDev(`/getquestions/${type}/${year}`);  
        QuestionModel.deleteAll();
        if(response.data.status==='valid') {  
            let formInstance = null;
            if (formId) {
                formInstance = await getMonthlyFormAnswers(formId);
            }   
            if( (type=='MonthlySPCC' || 'MonthlySW' /* || type=='MonthlyUSTRect' */) && formId) {
                response.data.data.pop();
                response.data.data.pop();
            } 
            /* if(type=='MonthlyUSTRect' && response.data.data.length>8 && formId) {  
                response.data.data.pop();
                response.data.data.pop();
            } */
            (response.data.data || []).reverse().forEach((instance, index) => { 
                if (instance.Question.toLowerCase() === 'time') {
                    return;
                }
                if(type=='MonthlySPCC' && formId) {
                    if(instance.Question.toLowerCase() === 'acknowledged by' || instance.Question.toLowerCase() === 'actual date') {
                        return;
                    }
                }
                if(type=='MonthlySW' && formId) {
                    if(instance.Question.toLowerCase() === 'acknowledged by' || instance.Question.toLowerCase() === 'actual date') {
                        return;
                    }
                }
               /*  if(type=='MonthlyUSTRect' && formId) {
                    if(instance.Question.toLowerCase() === 'submitted by' || instance.Question.toLowerCase() === 'date') {
                        return;
                    }
                } */
                const newInstance = {
                    question: instance.Question,
                    quesNum: instance.Question_Num,
                    type: type,
                    id: index,
                    quesName: `q${instance.Question_Num}`,
                };  
                if (formId) { 
                    const modelInstance = marshallQuestionAndAnswers(instance, formInstance.questions[index], index, type); 
                    new QuestionModel(modelInstance).$save();
                    const questionsData: IMonthlyFormModelProps = {};
                    questionsData.id = formId;
                    questionsData.ImageUrls = formInstance.ImageUrls;
                    questionsData.SignatureUrls = formInstance.SignatureUrls;
                    questionsData.Completed = formInstance.Completed !== 0; 
                    new MonthlyFormModel(questionsData).$save();
                } else {
                    new QuestionModel(newInstance).$save();
                }
            });
            

            /* To maintain two question sets in monthly SPCC summary*/ 
            if(response.data.data2.length > 0) {
                (response.data.data2 || []).reverse().forEach((instance, index) => { 
                    if (instance.Question.toLowerCase() === 'time') {
                        return;
                    }
                    const newInstance = {
                        question: instance.Question,
                        quesNum: instance.Question_Num,
                        type: 'MonthlySPCC_OLD',
                        id: index,
                        quesName: `q${instance.Question_Num}`,
                    };  
                    new QuestionModelDuplicate(newInstance).$save();
                });
            }
            return response.data.data;
        }
    } catch (error) {
        toast.error('Something went wrong please try again later...!!', {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        throw error;
    }
}

export async function submitMonthlyForm(data: any, history: IHistory, images: string[], formId: string) { 
    try {
        let response = null;
        /* const ImageUrls = await uploadImages(images, 'images');
        data.ImageUrls = ImageUrls; */
        let SignatureData: any = []; 
        if(data.SignatureData) {
            let signature = getImageData(data.SignatureData, 'signatureData');
            SignatureData.push(signature); 
        }
        let ImageData: any = []; 
        if(images) {
            (images || []).forEach((item: string) => { 
                let image = getImageData(item, 'images');
                ImageData.push(image); 
            })
        }
        data.SignatureData = SignatureData;
        data.ImageData = ImageData;
        if (formId) {
            const updateData = {
                Answers: data.Answers,
                UserId: getCurrentUserUUID(),
                InspectionID: data.InspectionID,
                Date: data.Date,
                ImageUrls: data.ImageUrls || [],
                DeletedImages: data.DeletedImages,
                SignatureUrls: data.SignatureUrls, 
                SignatureData: data.SignatureData || [],
                ImageData: data.ImageData || []
            };
           /*  if (data.InspectionID === 'MonthlyUSTSpill') {
                response = await postDev('/form', data);
            } else { */
                response = await putDev(`/updateform/${formId}`, updateData);
            //}
            
        } else {
            response = await postDev('/form', data);
        }
        toast.success(FORM_SUBMISSION_SUCCESS, {
            position: toast.POSITION.TOP_CENTER,
            className: 'success-toast',
            autoClose: 1000,
            onClose: () => history.push('/inspections')
        });
        await getAllPlantsByRegion(getCurrentUserUUID(), 'All');
        return response;
    } catch (error) {
        toast.error('Something went wrong please try again later...!!', {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast',
            autoClose: 1000
        });
        throw error;
    }
}

export async function getMonthlyChecklistData(plantId: string, yyyy = format(new Date(), 'YYYY'), formType: string) {
    try {
        const response = await getDev(`/getmonthlyforms/${plantId}/${yyyy}/${formType}`);
        let flag = true;
        const answersData = marshallChecklistData(response.data.data);
        /* answersData.sort((a, b) => {
            return a.month - b.month;
        }); */
        new ChecklistModel({ id: plantId, answers: answersData, type: formType }).$save();
    } catch (error) {
        throw error;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/monthlyFormService.ts